<template>
  <div>
    <h2>Maske Karakterleri ve Örnekler</h2>
    <table style="text-align: center;" border="1" cellpadding="8" cellspacing="0">
      <thead>
        <tr>
          <th>Karakter</th>
          <th>Açıklama</th>
          <th>Maske</th>
          <th>Kullanıcı Girişi</th>
          <th>Sonuç</th>
        </tr>
      </thead>
      <tbody>
        <!-- # (Rakam) -->
        <tr>
          <td rowspan="5">#</td>
          <td rowspan="5">Rakam (0-9)</td>
          <td>(###) ###-####</td>
          <td>5551234567</td>
          <td>(555) 123-4567</td>
        </tr>
        <tr>
          <td>##:##</td>
          <td>1234</td>
          <td>12:34</td>
        </tr>
        <tr>
          <td>##/##/####</td>
          <td>25092025</td>
          <td>25/09/2025</td>
        </tr>
        <tr>
          <td>####-####-####-####</td>
          <td>1234123412341234</td>
          <td>1234-1234-1234-1234</td>
        </tr>
        <tr>
          <td>### ### ###</td>
          <td>123456789</td>
          <td>123 456 789</td>
        </tr>

        <!-- A (Harf) -->
        <tr>
          <td rowspan="5">A</td>
          <td rowspan="5">Harf (A-Z, a-z)</td>
          <td>AAA-###</td>
          <td>ABC123</td>
          <td>ABC-123</td>
        </tr>
        <tr>
          <td>AA-AA</td>
          <td>TRAB</td>
          <td>TR-AB</td>
        </tr>
        <tr>
          <td>AAAA</td>
          <td>TEST</td>
          <td>TEST</td>
        </tr>
        <tr>
          <td>AA/AA</td>
          <td>USNY</td>
          <td>US/NY</td>
        </tr>
        <tr>
          <td>A###</td>
          <td>X999</td>
          <td>X999</td>
        </tr>

        <!-- N (Alfanümerik) -->
        <tr>
          <td rowspan="5">N</td>
          <td rowspan="5">Alfanümerik (0-9, A-Z)</td>
          <td>NNN-NNN</td>
          <td>AB12CD</td>
          <td>AB1-2CD</td>
        </tr>
        <tr>
          <td>NN-####</td>
          <td>TR1234</td>
          <td>TR-1234</td>
        </tr>
        <tr>
          <td>NNNN</td>
          <td>A1B2</td>
          <td>A1B2</td>
        </tr>
        <tr>
          <td>NN/NN</td>
          <td>B7C8</td>
          <td>B7/C8</td>
        </tr>
        <tr>
          <td>NNN###</td>
          <td>XY9123</td>
          <td>XY9-123</td>
        </tr>

        <!-- X (Herhangi bir karakter) -->
        <tr>
          <td rowspan="5">X</td>
          <td rowspan="5">Herhangi bir karakter</td>
          <td>XX-###</td>
          <td>@A123</td>
          <td>@A-123</td>
        </tr>
        <tr>
          <td>XXX-XXX</td>
          <td>#AB$12</td>
          <td>#AB-$12</td>
        </tr>
        <tr>
          <td>XXXX</td>
          <td>!A2*</td>
          <td>!A2*</td>
        </tr>
        <tr>
          <td>XX/XX</td>
          <td>AB12</td>
          <td>AB/12</td>
        </tr>
        <tr>
          <td>XX-XX-XX</td>
          <td>1A@B#C</td>
          <td>1A-@B-#C</td>
        </tr>

        <!-- ? (İsteğe Bağlı Karakter) -->
        <tr>
          <td rowspan="5">?</td>
          <td rowspan="5">İsteğe bağlı bir sonraki karakter (girilebilir ya da boş bırakılabilir)</td>
          <td>+90 (###) ###-##??</td>
          <td>5321234567</td>
          <td>+90 (532) 123-4567</td>
        </tr>
        <tr>
          <td>###-??##</td>
          <td>12345</td>
          <td>123-45</td>
        </tr>
        <tr>
          <td>AA?-###</td>
          <td>AB123</td>
          <td>AB-123</td>
        </tr>
        <tr>
          <td>##/##/####?</td>
          <td>01012025</td>
          <td>01/01/2025</td>
        </tr>
        <tr>
          <td>TR-###??</td>
          <td>123</td>
          <td>TR-123</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>

export default {
  props: {
    form: Object
  },
  data() {
    return {
 
    };
  },
  created() {

  },
  methods: {

  }
};
</script>
